import AppService from "./app-service"
import objectToList from "@/utils/object-to-list"

const path = "customer-invoices"

export default class CustomerInvoiceService extends AppService {

  constructor() {
    super({ path })
  }

  static get STATUS() {
    return {
      waiting: {
        id: "waiting",
        icon: "clock outline orange icon",
        label: '<i class="clock outline orange icon"></i> Aguardando aprovação',
        description: "Aguardando aprovação",
      },
      approved: { 
        id: "approved",
        icon: "check circle green icon",
        label: '<i class="check circle green icon"></i> Aprovado',
        description: "Aprovado",              
      },            
    }
  }

  static getStatusList() {    
    return objectToList(CustomerInvoiceService.STATUS)
  }

  getUninvoicedCustomers(filter) {
    return this.http.post(`${path}/uninvoiced-customers`, filter) 
  }

  getUninvoicedCerts(filter) {
    return this.http.post(`${path}/uninvoiced-certs`, filter) 
  }

  filter(data) {
    return this.http.post(`${path}/filter`, data)
  }

  approve(id) {
    return this.http.post(`${path}/${id}/approve`)
  }

  disapprove(id) {
    return this.http.post(`${path}/${id}/disapprove`)
  }

  getLastInvoiceDate(customerId) {
    return this.http.get(`${path}/${customerId}/last-invoice-date`) 
  }

  hasInvoice(customerId, date) {
    return this.http.post(`${path}/has-invoice`, { customerId, date }).then((data) => data.hasInvoice)
  }
}